import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-auto" data-testid="footer">
      {/* Featured In Badge */}
      <div className="border-b border-slate-200 py-6">
        <div className="container-main text-center">
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-4">AffordScope Featured In</p>
          <img src="/featured-in.png" alt="AffordScope featured in FOX, Google News, and Digital Journal" className="mx-auto h-8 md:h-10 object-contain" />
        </div>
      </div>

      <div className="container-main py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 no-underline mb-3">
              <div className="w-7 h-7 rounded-lg bg-primary flex items-center justify-center">
                <span className="text-white font-bold text-xs">A</span>
              </div>
              <span className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Afford<span className="text-emerald-600">Scope</span>
              </span>
            </Link>
            <p className="text-sm text-slate-500 max-w-sm leading-relaxed mb-3">
              Free salary and cost of living tools to help you make smarter financial decisions about where to live and work in the US.
            </p>
            <p className="text-xs text-slate-400">Contact: <a href="mailto:support@lifeownit.com" className="text-emerald-600 hover:underline">support@lifeownit.com</a></p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-3 uppercase tracking-wider">Tools</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-slate-500 hover:text-slate-800 no-underline">Salary Calculator</Link>
              <Link to="/compare" className="block text-sm text-slate-500 hover:text-slate-800 no-underline">City Comparison</Link>
              <Link to="/blog" className="block text-sm text-slate-500 hover:text-slate-800 no-underline">Blog</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-3 uppercase tracking-wider">Legal</h4>
            <div className="space-y-2">
              <Link to="/privacy" className="block text-sm text-slate-500 hover:text-slate-800 no-underline">Privacy Policy</Link>
              <Link to="/terms" className="block text-sm text-slate-500 hover:text-slate-800 no-underline">Terms of Service</Link>
              <Link to="/disclaimer" className="block text-sm text-slate-500 hover:text-slate-800 no-underline">Disclaimer & Disclosure</Link>
            </div>
          </div>
        </div>

        {/* Financial Disclaimer */}
        <div className="border-t border-slate-200 mt-8 pt-6">
          <div className="bg-slate-100 rounded-lg p-4 mb-4">
            <p className="text-xs text-slate-500 leading-relaxed">
              <strong className="text-slate-600">Financial Disclaimer:</strong> This is not financial advice. All salary calculations, tax estimates, and cost of living data shown on AffordScope are approximations for informational purposes only. Actual costs may vary. Always consult a qualified financial advisor before making financial decisions.
            </p>
          </div>

          {/* Affiliate Disclosure */}
          <p className="text-[11px] text-slate-400 leading-relaxed mb-4">
            <strong>Affiliate Disclosure:</strong> This site contains affiliate links. When you click on certain links and make a purchase or sign up, we may receive a commission at no additional cost to you. 
            This does not affect our content or recommendations. <Link to="/disclaimer" className="text-emerald-600 hover:underline">Full disclosure</Link>.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <p className="text-xs text-slate-400">&copy; {new Date().getFullYear()} AffordScope. All rights reserved.</p>
            <p className="text-xs text-slate-400">Data is estimated. Not financial advice.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
